<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

  <v-app-bar
      app
      color="grey lighten-4"
    >
          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>




  </v-app-bar>
  
    <div>
    <v-alert
      v-model="alert"
      type="success"
      border="left"
      close-text="Close Alert"
      dismissible
    >
     Congratulations!  You have updated your account. Please try to login with the link provided in your email.
    </v-alert>

  </div>


  <v-card
    class="mx-auto"
    max-width="500"
  >
  <v-card-text>
 <div class="text--primary">
        Please update your account by providing a new password.
      </div>
  </v-card-text>
    <v-card-text>
      

    <v-text-field
      v-model="username"
      label="Username"
      solo
      outlined
      disabled = true
    ></v-text-field>
    <v-alert type="success" v-model="validCode">
      Valid Email.
    </v-alert>

     <v-alert type="error" v-model="invalidCode">
     Invalid Email
    </v-alert>

    </v-card-text>

    <v-card-text>

      <v-text-field
      v-model="password"
      :type="'password'"
      label="Password"
      solo
      outlined
    ></v-text-field>

    </v-card-text>

     <v-card-text>
    <v-text-field
      v-model="reTypePassword"
      :type="'password'"
      label="Retype Password"
      solo
      outlined
    ></v-text-field>

    <v-alert type="error" v-model="passwordAlert">
      {{message}}
    </v-alert>

     </v-card-text>
    <v-card-actions>
      <v-btn
      :disabled="disabled"
      color="success"
      class="mr-4"
      @click="updateUser"
    >
      Update Password
    </v-btn>
    </v-card-actions>

  </v-card>

   

    

     




    




 
  </v-form>
</template>


<script>

  import axios from 'axios';

  export default {
    data: () => ({
      passwordAlert: false,
      message: '',
      alert: false,
      pId: '',
      username: '',
      password: '',
      reTypePassword: '',
      disabled: false,
      valid: false,
      validCode: false,
      invalidCode: false,
      items: [],
      name: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      
      console.log("GETTING PARAMETER");
     

      this.pId = this.$route.query.id;

      console.log(this.pId);

      console.log(this.$route.query);

      this.getUserId(this.pId);

   
  },

    methods: {


      getUserId:function(inId) {

      axios.get('https://api.conciergepadedu.com/api/Users/GetUserUuid/' +  inId).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;
        this.disabled = true;


      } else {

        console.log(response.data);


        this.disabled = false;

        //successful
        this.validCode = true;
        this.invalidCode = false;

        this.items = response.data;
       

        console.log("SUCCESS");
        console.log(this.items.primarY_ACCOUNT);

        this.username = this.items.username;




        }

        }).catch(error => {

            console.log(error.response)

            this.disabled = true;

            this.validCode = false;
            this.invalidCode = true;


        });

    },
    updateUser() {


      if (this.password.length == 0 || this.reTypePassword == 0) {

        this.passwordAlert = true;
        this.message = "Password can't be blank";

      }
      else if (this.username == 0) {

        this.passwordAlert = true;
        this.message = "Username cannot be blank.  Please load up screen again.";
        
      }
      else if (this.password != this.reTypePassword) {

        this.passwordAlert = true;
        this.message = "Passwords have to match";
      }
       else if (this.password.length < 6) {

        this.passwordAlert = true;
        this.message = "Passwords have to be at least 6 digits";
      }

       else if (this.invalidCode == true) {

         console.log("Invalid Email");

      }

      else {

        this.passwordAlert = false;
        this.message = "";


      axios.put('https://api.conciergepadedu.com/api/Users/PutUser/' + this.items.id,{ 
         ID: this.items.id,
         USERNAME: this.username,
         PASSWORD:  this.password,
         COMPANY_NAME: this.items.companY_NAME,
         UUID: this.items.hangeR_ID,
         DATE_CREATED: this.items.datE_CREATED,
         MOBILE_PHONE:  this.items.mobilE_PHONE,
         FIRST_NAME: this.items.firsT_NAME,
         LAST_NAME: this.items.lasT_NAME,
         EMAIL: this.items.email,
         DOB: this.items.dob,
         HANGER_ID: this.items.hangeR_ID,
         PUSH_TOKEN:'',
         REGISTRATION_UUID: this.pId,
         PRIMARY_ACCOUNT: this.items.primarY_ACCOUNT,
         LINKED_ACCOUUNT: this.items.linkeD_ACCOUNT,
         ACTIVATE_FLAG: this.items.activE_FLAG
      }).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

      } else {


          this.alert = true;

          this.password = '';
          this.reTypePassword = '';
          this.validCode = false;
          this.invalidCode = false;
          this.items = [];
          this.disabled = true;
          this.$alert("Update Account Complete.  Please log into CONCIERGEpad Mobile App in App Store or Google Play with your username and password.","Add","success");


        } 

  

        }).catch(error => {

            console.log(error.response)




        });

      }

    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>